module.exports = __webpack_public_path__ + "img/icon-24-ic-arrow-e.eb71eefc.svg";